import { createEntityAdapter, createSlice, createSelector } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'

const invitationsAdapter = createEntityAdapter()

const invitationsSlice = createSlice({
  name: 'invitations',
  initialState: invitationsAdapter.getInitialState(),
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('invitations')) {
        invitationsAdapter.upsertMany(state, payload.invitations)
      }
    })
  },
})

// Selectors
const selectBase = state => state.data.invitations

export const invitationSelectors = invitationsAdapter.getSelectors(state => selectBase(state))

// selects all tables matching the given array of ids
export const selectInvitationsByIds = createSelector(
  (state, ids) => ids,
  invitationSelectors.selectEntities,
  function (ids, allinvitationsById) {
    return ids.map(invitationId => allinvitationsById[invitationId])
  }
)

export default invitationsSlice.reducer
